import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">

                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What are some examples of emerging tech that businesses should be aware of?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>There are many examples of emerging tech that businesses should be aware of,
                                        including artificial intelligence, blockchain, virtual and augmented reality,
                                        and the Internet of Things. Other examples may include 5G networks, autonomous
                                        vehicles, quantum computing, and biotechnology.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    How can my business stay up-to-date on emerging tech trends and opportunities?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>There are a few key ways businesses can stay up-to-date on emerging tech trends
                                        and opportunities. These include subscribing to industry publications and blogs,
                                        attending tech conferences and events, following tech influencers and experts on
                                        social media, and joining tech-focused professional organizations and
                                        communities. It's also a good idea to regularly review your business goals and
                                        needs and to be open to trying new technologies that may help you to achieve
                                        those goals.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    Can TekRevol help my business leverage emerging tech for competitive advantage?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol has a team of experienced professionals specializing in emerging
                                        technology. We have a successful track record of helping businesses to leverage
                                        emerging tech to achieve their goals and gain a competitive advantage. Our team
                                        has the skills and knowledge to help you create a custom solution that meets
                                        your specific needs and goals. Whether you're looking to improve your
                                        operations, increase your sales, or stay ahead of the curve in your industry, we
                                        can help you leverage emerging tech to achieve your goals.</p>
                                </Accordion.Body>
                            </Accordion.Item>


                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;